var map = {
	"./ACCOUNTING/equip.svg": 53617,
	"./AUTO/equip.svg": 20051,
	"./AUTOCOMP/equip.svg": 8862,
	"./AUTOWASH/equip.svg": 46374,
	"./BARBERSHOP/equip.svg": 11236,
	"./BIKE/equip.svg": 69005,
	"./BOAT/equip.svg": 23228,
	"./BRICO/equip.svg": 94371,
	"./CLASS/equip.svg": 37272,
	"./DEFAULT/equip.svg": 26843,
	"./ELECTROMECH/equip.svg": 11087,
	"./ELEVATOR/equip.svg": 15440,
	"./EQUESTRIAN/equip.svg": 74101,
	"./FARRIER/equip.svg": 69481,
	"./GARDEN/equip.svg": 16361,
	"./GRAPHVINYL/equip.svg": 54630,
	"./HEALTH/equip.svg": 76896,
	"./HOMECLEAN/equip.svg": 35604,
	"./HOMEREPAIR/equip.svg": 21060,
	"./HOTEL/equip.svg": 24262,
	"./MARKETINGIMAGE/equip.svg": 66905,
	"./METALWORK/equip.svg": 63322,
	"./MOTO/equip.svg": 89305,
	"./NUTRITION/equip.svg": 10344,
	"./PHYSIO/equip.svg": 89586,
	"./POOL/equip.svg": 8780,
	"./TECH/equip.svg": 33098,
	"./TELECOMS/equip.svg": 47848,
	"./TRUCK/equip.svg": 77453,
	"./VET/equip.svg": 70349,
	"./WELLBEING/equip.svg": 4465,
	"./WOODWORK/equip.svg": 2358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71436;